<router-outlet />
<toast-notifications />
<version-no />
<user-helper />
